/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { FollowUpConfigurationFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type FollowUpConfigurationsQueryVariables = Exact<{
  [key: string]: never
}>

export type FollowUpConfigurationsQuery = {
  __typename: "Query"
  followUpConfigurations?: Array<{
    __typename: "FollowUpConfiguration"
    id: string
    position: number
    isActive?: boolean | null
    sourceProduct: {
      __typename: "DimConfiguration"
      id: string
      productName: string
      productType: string
      isActive?: boolean | null
      dimensioningKey?: string | null
    }
    targetProduct: {
      __typename: "DimConfiguration"
      id: string
      productName: string
      productType: string
      isActive?: boolean | null
      dimensioningKey?: string | null
    }
  }> | null
}

export const FollowUpConfigurationsDocument = gql`
  query FollowUpConfigurations {
    followUpConfigurations
      @rest(
        endpoint: "followUpConfiguration"
        type: "FollowUpConfiguration"
        path: "/dimensioning-data-exchange/follow-up-configuration"
      ) {
      ...FollowUpConfiguration
    }
  }
  ${FollowUpConfigurationFragmentDoc}
`

/**
 * __useFollowUpConfigurationsQuery__
 *
 * To run a query within a React component, call `useFollowUpConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowUpConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowUpConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFollowUpConfigurationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FollowUpConfigurationsQuery,
    FollowUpConfigurationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FollowUpConfigurationsQuery,
    FollowUpConfigurationsQueryVariables
  >(FollowUpConfigurationsDocument, options)
}
export function useFollowUpConfigurationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FollowUpConfigurationsQuery,
    FollowUpConfigurationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FollowUpConfigurationsQuery,
    FollowUpConfigurationsQueryVariables
  >(FollowUpConfigurationsDocument, options)
}
// @ts-ignore
export function useFollowUpConfigurationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FollowUpConfigurationsQuery,
    FollowUpConfigurationsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  FollowUpConfigurationsQuery,
  FollowUpConfigurationsQueryVariables
>
export function useFollowUpConfigurationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FollowUpConfigurationsQuery,
        FollowUpConfigurationsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  FollowUpConfigurationsQuery | undefined,
  FollowUpConfigurationsQueryVariables
>
export function useFollowUpConfigurationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FollowUpConfigurationsQuery,
        FollowUpConfigurationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FollowUpConfigurationsQuery,
    FollowUpConfigurationsQueryVariables
  >(FollowUpConfigurationsDocument, options)
}
export type FollowUpConfigurationsQueryHookResult = ReturnType<
  typeof useFollowUpConfigurationsQuery
>
export type FollowUpConfigurationsLazyQueryHookResult = ReturnType<
  typeof useFollowUpConfigurationsLazyQuery
>
export type FollowUpConfigurationsSuspenseQueryHookResult = ReturnType<
  typeof useFollowUpConfigurationsSuspenseQuery
>
export type FollowUpConfigurationsQueryResult = Apollo.QueryResult<
  FollowUpConfigurationsQuery,
  FollowUpConfigurationsQueryVariables
>
